import classNames from 'classnames';
import ReviewStars from '$components/basic/ReviewStars';
import type { AppGarage } from '$page-router/api/getGaragesByLatLong';
import { HeadingLevels } from '@/components/atoms/HeadingLevels';

import styles from './index.module.scss';

interface GarageInfoCardHeaderProps {
  readonly className?: string;
  readonly name: string;
  readonly ratingNumber: AppGarage['ratingNumber'];
  readonly reviewsNumber: AppGarage['ratingNumber'];
  readonly translations: {
    readonly reviewsNumberText: string;
  };
}

export function GarageInfoCardHeader({
  className,
  name,
  ratingNumber,
  reviewsNumber,
  translations: { reviewsNumberText },
}: GarageInfoCardHeaderProps): JSX.Element {
  return (
    <div className={classNames(GarageInfoCardHeader.displayName, className, styles.HeaderSection)}>
      <div>
        <HeadingLevels semanticLevel={3} styleLevel={6}>
          {name}
        </HeadingLevels>
        {!!ratingNumber && Number.isFinite(ratingNumber) && Number.isFinite(reviewsNumber) && (
          <div className={styles.RatingsSection}>
            <div className={styles.RatingNumber}>{ratingNumber}</div>
            <ReviewStars
              className={styles.ReviewStarsSection}
              stars={ratingNumber}
              starHeight={16}
              starWidth={16}
            />
            <div className={styles.ReviewsNumber}>
              {reviewsNumber} {reviewsNumberText}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

GarageInfoCardHeader.displayName = 'GarageInfoCardHeader';
